<mdb-card (click)="openModal()">
    <mdb-card-img src="assets/images/projects/{{projectData.name}}/header.png" alt="Card image cap">
    </mdb-card-img>
    <!--Card content-->
    <mdb-card-body>
        <!--Title-->
        <mdb-card-title>
            <h4>{{'projects.' + projectData.name + '.title' | translate }}</h4>
        </mdb-card-title>

        <!--Text-->
        <mdb-card-text>
            <!-- speech -->
            <div [innerHTML]="'projects.' + projectData.name + '.speech' | translate"></div>
            <br>

            <!-- Links -->
            <div flxLayout="row" fxLayoutAlign="space-around center" style="color:rgb(199, 167, 128);">
                <div *ngFor="let link of projectData.links; let i = index">
                    <div *ngIf="link.favicon" style="font-size:50px">
                        <a href={{link.href}}><i class="project-link {{link.favicon}}"></i></a>
                    </div>
                    <div *ngIf="link.image" style="font-size:40px;">
                        <a href="{{link.href}}"><img src="{{link.image}}" class="project-link"
                                style="width: 1.5em;"></a>
                    </div>
                </div>
            </div>
        </mdb-card-text>
    </mdb-card-body><!-- Card footer -->
    <div class="card-footer text-muted text-center">{{'projects.' + projectData.name + '.tags' | translate }}</div>
</mdb-card>